import styled from '@emotion/styled';
import { TextField } from '@mui/material';
import Theme from 'App.theme';

const InputField = styled(TextField)<{ width?: string; height?: string }>`
  margin: 0;
  width: auto;

  & .MuiFormLabel-root {
    font-family: ${Theme.font};
  }

  & .MuiInputLabel-root:not(.MuiInputLabel-shrink) {
    transform: translate(14px, 5px) scale(1);
  }

  & .MuiOutlinedInput-root {
    background-color: ${Theme.colours.white};
    font-family: ${Theme.font};
    border-radius: 0;
    padding: 10px 22px;
    min-width: ${p => p.width || `${Theme.sizes.minInputWidth}px`};
    width: ${p => p.width || 'auto'};
    height: ${p => p.height || '32px'};

    & .MuiOutlinedInput-input {
      padding: 0;
    }

    & fieldset: {
      border-color: ${Theme.greys.GREY0};
    }
    &:hover fieldset {
      /* border-color: ${Theme.colours.active}; */
    }

    &.Mui-focused fieldset {
      /* border-color: ${Theme.colours.active}; */
    }
    &.Mui-disabled fieldset {
      border-color: ${Theme.greys.GREY0};
    }
  }
`;

export default InputField;
